import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import * as stngs from '~js/utils/settings';
import {
  debounce,
} from '~js/utils/utils';

export class Ticker {
  constructor(el, stopClone = false) {
    this.frame = el;
    this.stopClone = stopClone;
    this.scale = this.frame.querySelector(s.selectors$E.scale);
    this.text = this.frame.querySelector(s.selectors$E.text);

    this.comparitor = this.text.cloneNode(true);
    this.comparitor.classList.add(c.classes$u.comparitorClass);
    this.frame.appendChild(this.comparitor);
    this.scale.classList.remove(c.classes$u.unloadedClass);
    this.resizeEvent = debounce(() => this.checkWidth(), 100);
    this.listen();
  }

  listen() {
    document.addEventListener('theme:resize:width', this.resizeEvent);
    this.checkWidth();
  }

  checkWidth() {
    const padding = window.getComputedStyle(this.frame).paddingLeft.replace('px', '') * 2;

    if (this.frame.clientWidth - padding < this.comparitor.clientWidth || this.stopClone) {
      if (this.scale.childElementCount === 1) {
        this.text.classList.add(c.classes$u.animationClass);
        this.clone = this.text.cloneNode(true);
        this.clone.setAttribute(s.selectors$E.clone, '');
        this.scale.appendChild(this.clone);

        if (this.stopClone) {
          for (let index = 0; index < 10; index++) {
            const cloneSecond = this.text.cloneNode(true);
            cloneSecond.setAttribute(s.selectors$E.clone, '');
            this.scale.appendChild(cloneSecond);
          }
        }

        let frameSpeed = this.frame.getAttribute(a.attributes$p.speed);
        if (frameSpeed === null) {
          frameSpeed = 100;
        }
        const speed = stngs.settings$3.moveTime * (100 / parseInt(frameSpeed, 10));
        const animationTimeFrame = (this.text.clientWidth / stngs.settings$3.space) * speed;

        this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);
      }
    } else {
      this.text.classList.add(c.classes$u.animationClass);
      let clone = this.scale.querySelector(`[${s.selectors$E.clone}]`);
      if (clone) {
        this.scale.removeChild(clone);
      }
      this.text.classList.remove(c.classes$u.animationClass);
    }
  }

  unload() {
    document.removeEventListener('theme:resize:width', this.resizeEvent);
  }
}